@if (isFolder()) {
  <div class="folder" >
    <div class="folder-icon" (click)="selectItemIcon()"><mat-icon>folder</mat-icon></div>
    <div class="name" (click)="selectItem()">
      <ldw-truncated-text [text]="item.text"></ldw-truncated-text>
    </div>
  </div>
}
@if (isDocument()) {
  <div class="document">
    <div class="links">
      <a [routerLink]="['/', viewRouteBase, webDokuId, item.id]"
        [queryParams]="{ search: search }"
        queryParamsHandling="merge"
        routerLinkActive="router-link-active" ldwShouldOpenInNewTab>
        @if (item.isDefault()) {
          <div class="first-icon"><mat-icon class="file-icon">draft</mat-icon></div>
        }
        @if (item.isNew()) {
          <div class="first-icon"><mat-icon class="file-icon">note_add</mat-icon></div>
        }
        @if (item.isChanged()) {
          <div class="first-icon"><mat-icon class="file-icon">edit_document</mat-icon></div>
        }
      </a>
      <a class="name"
        [routerLink]="['/', viewRouteBase, webDokuId, item.id]"
        [queryParams]="{ search: search }"
        queryParamsHandling="merge"
        ldwShouldOpenInNewTab
        >
        <div class="name" style="min-width: 0">
          <ldw-truncated-text [text]="item.text"></ldw-truncated-text>
          @if (showTreePath) {
            <div class="pathtext"><ldw-truncated-text [text]="item.treePath"></ldw-truncated-text></div>
          }
          <div class="item">
            <ldw-document-images [document]="item"></ldw-document-images>
            <ldw-status-label [status]="status"></ldw-status-label>
          </div>
        </div>
      </a>
    </div>
    <div class="buttons">
      @if (allowPreview()) {
        <button
          mat-icon-button
          (click)="previewClicked($event)"
          matTooltip="{{ showToolTip()? ('DIALOGS.PREVIEW' | translate) :''  }}"
          >
          <mat-icon>visibility</mat-icon>
        </button>
      }
      @if (allowEdit()) {
        <a
          mat-icon-button
          [routerLink]="['/', editRouteBase, webDokuId, item.id]"
          [queryParams]="{ search: search }"
          queryParamsHandling="merge"
          ldwShouldOpenInNewTab
          matTooltip="{{ showToolTip()? ('DIALOGS.EDIT' | translate) :'' }}"
          ><mat-icon>create</mat-icon></a
          >
        }
      </div>
    </div>
  }
  @if (isNode()) {
    <div class="node">
      <div class="node-image-wrapper" (click)="selectItemIcon()">
        <img class="nodeimage" [src]="getNodeImage()" alt="node image" />
        <!-- <mat-icon>{{nodeIcon()}}</mat-icon> -->
      </div>
      <div class="name" (click)="selectItem()"><ldw-truncated-text [text]="item.text"></ldw-truncated-text></div>
    </div>
  }
